import deepMerge from 'deepmerge';
export var extendChartSettings = function (chartsSettingsFromQuery, baseSettings) {
    return deepMerge(chartsSettingsFromQuery, baseSettings, {
        arrayMerge: function (_target, source) { return source; },
    });
};
